import {USDonChange, USDtoValue} from "../fields/USDField";

export const UnionAffiliationColumns = [
  { header: "Sector", accessor: "sector" },
  { header: "Trade", accessor: "trade" },
  { header: "Affiliation", accessor: "affiliation" },
];
export const marketsColumns = [
  { header: "Sector", accessor: "sector" },
 // { header: "Subsector", accessor: "subsector" },
  { header: "Project Size Min", accessor: "project_size_min", toValue: USDtoValue, fromValue:USDonChange},
  { header: "Project Size Max", accessor: "project_size_max", toValue: USDtoValue, fromValue:USDonChange },
];
